import React from 'react';
import PropTypes from 'prop-types';
import MaterialSlider from '@material-ui/core/Slider';
import classnames from 'classnames';
import styles from './Slider.scss';

const Slider = ({ className, ...props }) =>
    <MaterialSlider
        className={classnames(styles.sliderWrapper, className)}
        { ...props }
    />;

Slider.propTypes = {
    className: PropTypes.string
};

Slider.defaultProps = {
    className: ''
};

export default Slider;
